'use client';
function getFloatingPosition(dir, position) {
    if (dir === 'rtl' && (position.includes('right') || position.includes('left'))) {
        const [side, placement] = position.split('-');
        const flippedPosition = side === 'right' ? 'left' : 'right';
        return placement === undefined ? flippedPosition : `${flippedPosition}-${placement}`;
    }
    return position;
}

export { getFloatingPosition };
//# sourceMappingURL=getFloatingPosition.js.map
